import React from "react";
import { withRouter } from "react-router-dom";
import WineBlock from "../components/WineBlock";
import Rosalita from "../images/corner/corner-rosalita.webp";
import classnames from "classnames";
import _ from "underscore";
import FullPageLoader from "../components/FullPageLoader";

class OurWines extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wineName: null,
      showWineModal: false,
      searchFilter: [],
      uncommonListSelected: false,
    };
  }
  componentDidMount() {
    document.title = "Auburn Road - Our Wines";
  }
  openWineModal = (wine) => {
    document.getElementById("body").classList.add("scroll-lock");
    this.setState({ wineName: wine });
  };
  hideWineModal = () => {
    this.setState({ wineName: null });
    document.getElementById("body").classList.remove("scroll-lock");
  };
  handleSearch = (e) => {
    const event = e.target.value;
    this.setState({
      searchFilter: event,
    });
  };

  wineSearch = (e) => {
    const selected = e.target.className === "wine-keyword--selected";
    if (selected) {
      const findWine = this.state.searchFilter.indexOf(e.target.outerText);
      const list = this.state.searchFilter;
      list.splice(findWine, 1);
      this.setState({ searchFilter: list });
      e.target.className = "wine-keyword";
    } else {
      this.setState({
        searchFilter: this.state.searchFilter.concat(e.target.outerText),
      });
      e.target.className = "wine-keyword--selected";
    }
  };
  render() {
    if (!this.props.info) {
      return <FullPageLoader />;
    }
    let data = this.props.info.filter((x) => {
      if (this.state.searchFilter) {
        return this.state.searchFilter.every(
          (r) => (x.keywords || []) && x.fields.keywords.includes(r)
        );
      } else {
        return true;
      }
    });
    const renderWineBlocks = data.map((wine) => {
      const w = wine;
      return (
        <WineBlock
          wineInfo={w}
          key={w.wine_name}
          openModal={() => this.openWineModal(wine)}
        />
      );
    });

    return (
      <>
        <img src={Rosalita} className="corner-rosalita" alt="" />
        <div className="container content-page our-wines-page p-t-100">
          <section
            className={classnames("content-hero", {
              "hide-quote": !_.isEmpty(this.state.searchFilter),
            })}
          >
            <h1 className="huge-text-no-quote content-hero__title">
              Our Wines
            </h1>
            <p className="content-hero__intro">
              Estate wines crafted by Jules. Explore the bottles that tell the
              Auburn Road story.
            </p>
          </section>
          <div className="wine-block-grid">
            {_.isEmpty(data) ? (
              <p>sorry, your search did not return any results</p>
            ) : (
              renderWineBlocks
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(OurWines);
